import(/* webpackMode: "eager" */ "/opt/fa-build/src/app/(home)/layout.js");
